const isIsoLikeDateValue = (value) => {
    if (value === null || value === undefined || value === "") return false;
    if (typeof value === "number") return Number.isFinite(value);
    const text = String(value).trim();
    if (!text) return false;
    if (/^\d{4}-\d{2}-\d{2}/.test(text)) return true;
    if (/^\d{13}$/.test(text)) return true;
    return false;
};

export const parseCalendarDate = (raw) => {
    if (raw === null || raw === undefined || raw === "") return null;
    try {
        const d = typeof raw === "number" ? new Date(raw) : new Date(raw);
        if (isNaN(d.getTime())) return null;
        return new Date(d.getFullYear(), d.getMonth(), d.getDate());
    } catch {
        return null;
    }
};

/**
 * Resolve a calendar date for chat date dividers.
 * Skips display-only time strings (e.g. "10:04 pm") in favor of ISO timestamps.
 */
export const resolveMessageCalendarDate = (message) => {
    if (!message || typeof message !== "object") return null;

    const candidates = [
        message.created_at,
        message.timestamp,
        message.original?.created_at,
        message.original?.timestamp,
    ];

    if (isIsoLikeDateValue(message.time)) {
        candidates.push(message.time);
    }

    for (const raw of candidates) {
        const date = parseCalendarDate(raw);
        if (date) return date;
    }

    return null;
};
